import { type AiBuilderUsageInfo } from './types';

export const isAiBuilderUsageBlocked = (
  usage: AiBuilderUsageInfo | null,
): boolean => !!usage && usage.limit > -1 && usage.state === 'blocked';
